/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { chiefAccountant, certificateNumber, unitHeads, dateFounded } = formField;

  return (
    <Box mt={3}>
      <Box mb={4}>
        <Typography variant="h6">NHÂN VIÊN ĐẠI LÝ THUẾ</Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={chiefAccountant.label}
            name={chiefAccountant.name}
            value={values.chiefAccountant}
            error={errors.chiefAccountant && touched.chiefAccountant}
            success={values.chiefAccountant?.toString().length > 0 && !errors.chiefAccountant}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={unitHeads.label}
            name={unitHeads.name}
            value={values.unitHeads}
            error={errors.unitHeads && touched.unitHeads}
            success={values.unitHeads?.toString().length > 0 && !errors.unitHeads}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={certificateNumber.label}
            name={certificateNumber.name}
            value={values.certificateNumber}
            error={errors.certificateNumber && touched.certificateNumber}
            success={values.certificateNumber?.toString().length > 0 && !errors.certificateNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={dateFounded.label}
            name={dateFounded.name}
            error={errors.dateFounded && touched.dateFounded}
            success={values.dateFounded?.toString().length > 0 && !errors.dateFounded}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
